import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetSuspectedStudentsRankingUseCaseInterface } from 'domain/usecases';

export class RemoteGetSuspectedStudentsRanking
  implements GetSuspectedStudentsRankingUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetSuspectedStudentsRankingUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetSuspectedStudentsRankingUseCaseInterface.Params,
  ): Promise<GetSuspectedStudentsRankingUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, { ...params });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
